//Effects
import { all, put, select, takeLatest } from "redux-saga/effects";

import {
  ADD_SUB_TASK,
  ADD_SUB_TASK_FAILURE,
  ADD_SUB_TASK_SUCCESS,
  ADD_TASK_LOCATION,
  ADD_TASK_LOCATION_FAILURE,
  ADD_TASK_LOCATION_SUCCESS,
  CREATE_TASK,
  CREATE_TASK_FAILURE,
  CREATE_TASK_SUCCESS,
  DELETE_SUB_TASK,
  DELETE_SUB_TASK_FAILURE,
  DELETE_SUB_TASK_SUCCESS,
  DELETE_TASK,
  DELETE_TASK_FAILURE,
  DELETE_TASK_LOCATION,
  DELETE_TASK_LOCATION_FAILURE,
  DELETE_TASK_LOCATION_SUCCESS,
  DELETE_TASK_SUCCESS,
  DUPLICATE_TASK,
  DUPLICATE_TASK_FAILURE,
  DUPLICATE_TASK_SUCCESS,
  EDIT_SUB_TASK,
  EDIT_SUB_TASK_FAILURE,
  EDIT_SUB_TASK_SUCCESS,
  EDIT_TASK,
  EDIT_TASK_FAILURE,
  EDIT_TASK_LOCATION,
  EDIT_TASK_LOCATION_FAILURE,
  EDIT_TASK_LOCATION_SUCCESS,
  EDIT_TASK_SUCCESS,
  GET_TASKS_LIST,
  GET_TASKS_LIST_FAILURE,
  GET_TASKS_LIST_SUCCESS,
  GET_TASK_DETAILS,
  GET_TASK_DETAILS_FAILURE,
  GET_TASK_DETAILS_SUCCESS,
  GET_TASK_HISTORY,
  GET_TASK_HISTORY_FAILURE,
  GET_TASK_HISTORY_SUCCESS,
  GET_TASK_LOCATIONS,
  GET_TASK_LOCATIONS_FAILURE,
  GET_TASK_LOCATIONS_SUCCESS,
  GET_TASK_TYPE,
  GET_TASK_TYPE_FAILURE,
  GET_TASK_TYPE_SUCCESS,
  REMOVE_TASK_ASSIGNEE,
  REMOVE_TASK_ASSIGNEE_FAILURE,
  REMOVE_TASK_ASSIGNEE_SUCCESS,
  UPDATE_PARTIAL_TASK,
  UPDATE_PARTIAL_TASK_FAILURE,
  UPDATE_PARTIAL_TASK_SUCCESS,
  UPDATE_TASK_ASSIGNEE,
  UPDATE_TASK_ASSIGNEE_FAILURE,
  UPDATE_TASK_ASSIGNEE_SUCCESS,
  UPDATE_TASK_STATUS,
  UPDATE_TASK_STATUS_FAILURE,
  UPDATE_TASK_STATUS_SUCCESS,
  REASSIGN_ASSIGNEE,
  REASSIGN_ASSIGNEE_SUCCESS,
  REASSIGN_ASSIGNEE_FAILURE,
} from "../../modules/constants";
//Service
import { defaultApi } from "../../utils/axiosApi";

export function* handleGetTasksList({ payload }) {
  const {
    startDate,
    endDate,
    page,
    task_name,
    office_id,
    assignee_id,
    status,
    approval_status,
  } = payload;
  try {
    const url = `/tasks/?required_start_date=${startDate}&required_end_date=${endDate}${
      page ? `&page=${page}` : ""
    }${task_name ? `&name=${task_name}` : ""}${
      office_id ? `&office_id=${office_id}` : ""
    }${assignee_id ? `&assignees=${assignee_id}` : ""}${
      status ? `&status=${status}` : ""
    }${approval_status ? `&approval_status=${approval_status}` : ""}`;
    const response = yield defaultApi(url, "GET", payload);
    yield put({
      type: GET_TASKS_LIST_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_TASKS_LIST_FAILURE,
      payload: err,
    });
  }
}

export function* handleCreateTaskList({ payload }) {
  try {
    const { ...details } = payload;
    const url = `/tasks/`;
    const method = "POST";
    const response = yield defaultApi(url, method, details);
    yield put({
      type: CREATE_TASK_SUCCESS,
      payload: { data: response, notify: "POST" },
    });
  } catch (err) {
    yield put({
      type: CREATE_TASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleGetTaskDetails({ payload }) {
  try {
    const { task_id } = payload;
    const url = `/tasks/${task_id}/`;
    const method = "GET";
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_TASK_DETAILS_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_TASK_DETAILS_FAILURE,
      payload: err,
    });
  }
}

export function* handleGetTaskHistory({ payload }) {
  try {
    const { task_id } = payload;
    const url = `/tasks/${task_id}/history/`;
    const response = yield defaultApi(url, "GET");
    yield put({
      type: GET_TASK_HISTORY_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_TASK_HISTORY_FAILURE,
      payload: err,
    });
  }
}

export function* handleReassignAssignee({ payload }) {
  try {
    const { task_id, ...details } = payload;
    const url = `/tasks/${task_id}/admin-reassign/`;
    const response = yield defaultApi(url, "POST", details);
    yield put({
      type: REASSIGN_ASSIGNEE_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({ type: REASSIGN_ASSIGNEE_FAILURE, payload: err });
  }
}

export function* handleUpdatePartialTask({ payload }) {
  try {
    const { task_id, ...details } = payload;
    const url = `/tasks/${task_id}/`;
    const response = yield defaultApi(url, "PATCH", details);
    yield put({
      type: UPDATE_PARTIAL_TASK_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: UPDATE_PARTIAL_TASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleEditTask({ payload }) {
  try {
    const { task_id, ...details } = payload;
    const url = `/tasks/${task_id}/`;
    const response = yield defaultApi(url, "PUT", details);
    yield put({
      type: EDIT_TASK_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: EDIT_TASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleUpdateTaskAssignee({ payload }) {
  console.log("🚀 ~ function*handleUpdateTaskAssignee ~ payload:", payload);
  try {
    const { task_id, ...data } = payload;
    const url = `/tasks/${task_id}/assignees/`;
    const response = yield defaultApi(url, "POST", {
      user_id: data.id,
    });
    yield put({
      type: UPDATE_TASK_ASSIGNEE_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: UPDATE_TASK_ASSIGNEE_FAILURE,
      payload: err,
    });
  }
}

export function* handleRemoveTaskAssignee({ payload }) {
  console.log("🚀 ~ function*handleRemoveTaskAssignee ~ payload:", payload);
  try {
    const { task_id, ...data } = payload;
    const url = `/tasks/${task_id}/assignees/${data.id}`;
    const response = yield defaultApi(url, "DELETE");
    yield put({
      type: REMOVE_TASK_ASSIGNEE_SUCCESS,
      payload: { data: response, task_id, user_id: data.id },
    });
  } catch (err) {
    yield put({
      type: REMOVE_TASK_ASSIGNEE_FAILURE,
      payload: err,
    });
  }
}

export function* handleAddSubTask({ payload }) {
  try {
    const { task_id, ...details } = payload;
    const url = `/tasks/${task_id}/sub/`;
    const response = yield defaultApi(url, "POST", details.data);
    yield put({
      type: ADD_SUB_TASK_SUCCESS,
      payload: { task_id, data: response },
    });
  } catch (err) {
    yield put({
      type: ADD_SUB_TASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleEditSubTask({ payload }) {
  try {
    const { task_id, sub_task_id, ...details } = payload;
    const url = `/tasks/${task_id}/sub/${sub_task_id}/`;
    const response = yield defaultApi(url, "PATCH", details.data);
    yield put({
      type: EDIT_SUB_TASK_SUCCESS,
      payload: { task_id, sub_task_id, data: response },
    });
  } catch (err) {
    yield put({
      type: EDIT_SUB_TASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleDeleteSubTask({ payload }) {
  try {
    const { task_id, sub_task_id } = payload;
    const url = `/tasks/${task_id}/sub/${sub_task_id}/`;
    const response = yield defaultApi(url, "DELETE");
    yield put({
      type: DELETE_SUB_TASK_SUCCESS,
      payload: { task_id, sub_task_id, data: response },
    });
  } catch (err) {
    yield put({
      type: DELETE_SUB_TASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleDuplicateTask({ payload }) {
  try {
    const { organization_id, ...details } = payload;
    const url = `/tasks/duplicate-task`;
    const method = "POST";
    const response = yield defaultApi(url, method, details);

    yield put({
      type: DUPLICATE_TASK_SUCCESS,
      payload: { data: response, notify: "POST" },
    });
  } catch (err) {
    yield put({
      type: DUPLICATE_TASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleDeleteTask({ payload }) {
  try {
    const { task_id } = payload;
    const url = `/tasks/${task_id}/`;
    const method = "DELETE";
    const response = yield defaultApi(url, method);
    yield put({
      type: DELETE_TASK_SUCCESS,
      payload: { data: response, task_id, notify: "DELETE" },
    });
  } catch (err) {
    yield put({
      type: DELETE_TASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleGetTaskLocations({ payload }) {
  try {
    let monazim;
    if (payload && payload.monazim) {
      monazim = payload.monazim;
    }
    const queryString = payload
      ? Object.keys(payload)
          .map(
            (key) =>
              `${encodeURIComponent(key)}=${encodeURIComponent(payload[key])}`
          )
          .join("&")
      : null;
    const url = `/task_locations/${queryString ? `?${queryString}` : ""}`;
    // const url = `/task_locations/${office_id ? `?office_id=${office_id}` : ''}`;
    const response = yield defaultApi(url, "GET");
    yield put({
      type: GET_TASK_LOCATIONS_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_TASK_LOCATIONS_FAILURE,
      payload: err,
    });
  }
}

export function* handleAddTaskLocation({ payload }) {
  try {
    const { ...details } = payload;
    const url = `/task_locations/`;
    // const url = `/task_locations/`;
    const method = "POST";
    const response = yield defaultApi(url, method, details);

    yield put({
      type: ADD_TASK_LOCATION_SUCCESS,
      payload: { data: response, notify: "POST" },
    });
  } catch (err) {
    yield put({
      type: ADD_TASK_LOCATION_FAILURE,
      payload: err,
    });
  }
}

export function* handleEditTaskLocation({ payload }) {
  try {
    const { location_id, ...details } = payload;
    const url = `/task_locations/${location_id}/`;
    const method = 'PATCH';
    const response = yield defaultApi(url, method, details);

    yield put({
      type: EDIT_TASK_LOCATION_SUCCESS,
      payload: { data: response, location_id, office_id: payload.office_id },
    });

    // Retrieve current filter state to reload locations with same filters
    const filterPayload = {};
    if (payload.selectedOffice && payload.selectedOffice.value) {
      filterPayload.office_id = payload.selectedOffice.value;
    }
    if (payload.selectedRegion && payload.selectedRegion.value) {
      filterPayload.region = payload.selectedRegion.value;
    }
    if (payload.searchTerm && payload.searchTerm !== '') {
      filterPayload.name = payload.searchTerm;
    }

    // Refresh location list with preserved filters (Cause backend insisted not changing response)
    yield handleGetTaskLocations({ payload: filterPayload });
  } catch (err) {
    yield put({
      type: EDIT_TASK_LOCATION_FAILURE,
      payload: err,
    });
  }
}

export function* handleDeleteTaskLocation({ payload }) {
  try {
    const { location_id } = payload;
    const url = `/task_locations/${location_id}/`;
    const method = 'DELETE';
    const response = yield defaultApi(url, method);

    yield put({
      type: DELETE_TASK_LOCATION_SUCCESS,
      payload: { data: response, location_id },
    });

    // Retrieve current filter state to reload locations with same filters
    const filterPayload = {};
    if (payload.selectedOffice && payload.selectedOffice.value) {
      filterPayload.office_id = payload.selectedOffice.value;
    }
    if (payload.selectedRegion && payload.selectedRegion.value) {
      filterPayload.region = payload.selectedRegion.value;
    }
    if (payload.searchTerm && payload.searchTerm !== '') {
      filterPayload.name = payload.searchTerm;
    }

    // Refresh location list with preserved filters
    yield handleGetTaskLocations({ payload: filterPayload });
  } catch (err) {
    yield put({
      type: DELETE_TASK_LOCATION_FAILURE,
      payload: err,
    });
  }
}

export function* handleTaskApproval({ payload }) {
  const { task_id, data } = payload;
  try {
    const url = `tasks/${task_id}/approval/${task_id}/`;
    const method = "PUT";
    const response = yield defaultApi(url, method, data);
    yield put({
      type: UPDATE_TASK_STATUS_SUCCESS,
      payload: { data: response, task_id },
    });
  } catch (err) {
    yield put({
      type: UPDATE_TASK_STATUS_FAILURE,
      payload: err,
    });
  }
}

export function* handleGetTaskType({}) {
  try {
    const url = `/tasks/ticket-type/`;
    const response = yield defaultApi(url, "GET", null);
    yield put({
      type: GET_TASK_TYPE_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_TASK_TYPE_FAILURE,
      payload: err,
    });
  }
}

export default function* root() {
  yield all([
    // Get tasks list
    takeLatest(GET_TASKS_LIST, handleGetTasksList),
    // Create task
    takeLatest(CREATE_TASK, handleCreateTaskList),
    //Get task details
    takeLatest(GET_TASK_DETAILS, handleGetTaskDetails),
    //Get task history
    takeLatest(GET_TASK_HISTORY, handleGetTaskHistory),
    //Reassign assignee
    takeLatest(REASSIGN_ASSIGNEE, handleReassignAssignee),
    //Update task
    takeLatest(EDIT_TASK, handleEditTask),
    takeLatest(UPDATE_PARTIAL_TASK, handleUpdatePartialTask),
    //Add sub task
    takeLatest(ADD_SUB_TASK, handleAddSubTask),
    //Update sub task
    takeLatest(EDIT_SUB_TASK, handleEditSubTask),
    //Delete sub task
    takeLatest(DELETE_SUB_TASK, handleDeleteSubTask),
    //Duplicate task
    takeLatest(DUPLICATE_TASK, handleDuplicateTask),
    //Delete task
    takeLatest(DELETE_TASK, handleDeleteTask), // Get task location
    takeLatest(GET_TASK_LOCATIONS, handleGetTaskLocations),
    // Add task location
    takeLatest(ADD_TASK_LOCATION, handleAddTaskLocation),
    // Edit task location
    takeLatest(EDIT_TASK_LOCATION, handleEditTaskLocation),
    // Delete task location
    takeLatest(DELETE_TASK_LOCATION, handleDeleteTaskLocation),

    takeLatest(UPDATE_TASK_ASSIGNEE, handleUpdateTaskAssignee),
    takeLatest(REMOVE_TASK_ASSIGNEE, handleRemoveTaskAssignee),
    takeLatest(UPDATE_TASK_STATUS, handleTaskApproval),
    // Get task type
    takeLatest(GET_TASK_TYPE, handleGetTaskType),
  ]);
}
